export const MAX_COLOR_PICKER_PRESET = 9;

export const BASE_SECTION_COLOR = [
  '#925DDB',
  '#89CC79',
  '#76AED3',
  '#EC37A6',
  '#FBB64E',
  '#276ED6',
  '#F8723E',
  '#B4ACF4',
  '#FCD981',
  '#8DD8B0',
  '#DC153D',
  '#06BFFF',
  '#707F90',
  '#473D8B',
  '#D8BFD8',
  '#7F0100',
  '#008B8B',
  '#D1691E',
  '#9ACD31',
  '#9ACD31',
  '#BC8F8F',
  '#006300',
  '#87CDEB',
  '#9931CC',
  '#FF4500',
  '#02CED1',
  '#FF8C00',
  '#FFD701',
  '#695BCD',
  '#FE1393',
  '#2F4F4F',
  '#A0522D',
  '#1320FF',
  '#A020F0',
  '#98FA98',
  '#FF1FFF',
  '#1D90FF',
  '#DB7092',
  '#EFE68C',
  '#DDA1DD',
  '#D2B38C',
  '#0D17CC',
  '#FF9F7A',
  '#EF81EE',
  '#546A2F',
  '#7EFFD3',
  '#FF68B4',
  '#7F097F',
  '#01FA99',
  '#DAA521'
];
